import { Box, Typography } from '@mui/material';
import IncButton from 'components/inc-button/inc-button.component';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AvailabilityErrors = ({ error, onSwitchToPickup }) => {
  const { t } = useTranslation();
  return (
    <Box position="relative" minHeight="200px">
      <Typography>{error}</Typography>
      {onSwitchToPickup && (
        <Box display="flex" justifyContent="center" mt={2}>
          <IncButton
            data-testid="AvailabilityErrors.SwitchToPickup"
            onClick={onSwitchToPickup}
            sx={{ minWidth: { sm: '100px' } }}
          >
            {t('locations.card.switchToPickup.label')}
          </IncButton>
        </Box>
      )}
    </Box>
  );
};

export default AvailabilityErrors;
